import { initializeApp } from 'firebase/app';

// For Firebase JavaScript SDK v7.20.0 and later
const firebaseConfig = {
    apiKey: "AIzaSyBujD2_pTBW05BGMapaOy-IoOa7VVWBui8",
    authDomain: "business-impact-group-kit-app.firebaseapp.com",
    projectId: "business-impact-group-kit-app",
    storageBucket: "business-impact-group-kit-app.appspot.com",
    messagingSenderId: "199262046157",
    appId: "1:199262046157:web:2844432f9aa2f65cdf6684"
};

const app = initializeApp(firebaseConfig);

export default app;
